import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clear(event) {
    const fieldName = event.target.name.match(/\[([^\]]+)\]/)?.[1]
    if (!fieldName) return

    this.element.querySelector(`[data-validation-error="${fieldName}"]`)?.remove()
  }
}
